export default __webpack_public_path__ + "static/media/banner_md.957c316c.svg";